import isNil from 'lodash/isNil';

export const DATE_DISPLAY_FORMATS: Record<string, string[]> = {
  day: [
    'MMM DD, YYYY',
    'MMMM DD, YYYY',
    'DD MMM YYYY',
    'DD MMMM YYYY',
    'YYYY MMM DD',
    'YYYY MMMM DD',
    'MM/DD/YYYY',
    'DD/MM/YYYY',
    'YYYY/MM/DD',
  ],
  month: ['MMM YYYY', 'MMMM YYYY', 'YYYY MMM', 'YYYY MMMM', 'MM/YYYY', 'YYYY/MM'],
  year: ['YYYY'],
};

export function getDefaultDateDisplayFormat(precision: string | null | undefined): string | null {
  if (isNil(precision)) {
    return null;
  }
  const formats = DATE_DISPLAY_FORMATS[precision] || [];
  if (formats.length === 0) {
    return null;
  }
  return formats[0];
}
